/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

import {  Individu } from '@/types';

import { validationInformationsComplementaires } from '..';

const validationStep4 = (
  individu: Partial<Individu>,
) => {
  return ({
    ...validationInformationsComplementaires(individu),
  });
};

export default validationStep4;
